/** Upload using signed URLs before returning attachment metadata suitable for persistence. */
export async function completeQuoteHeaderUploads(
  requested: any[], signed: any[], put: (url: string, file: any) => Promise<any>, cleanUrl: (url: string) => string,
): Promise<any[]> {
  if (!Array.isArray(signed) || signed.length !== requested.length) throw new Error('Incomplete attachment signing response');
  const keys = requested.map(item => item?.s3Params?.fileKey);
  if (new Set(keys).size !== keys.length) throw new Error('Duplicate attachment names');
  return Promise.all(signed.map(async (item, index) => {
    if (!item || typeof item.s3_path !== 'string' || !requested[index]?.file ||
        item.s3Params?.fileKey !== requested[index]?.s3Params?.fileKey) throw new Error('Invalid attachment signing response');
    await put(item.s3_path, requested[index].file);
    return { ...item, s3_path: cleanUrl(item.s3_path), fileKey: item.s3Params.fileKey };
  }));
}
